<template>
  <div>
    <v-dialog v-model="model" width="auto">
      <v-card>
        <div class="tw-p-2 tw-max-w-md sm:tw-min-w-[350px] tw-w-full tw-px-4">
          <h2 class="tw-text-2xl tw-font-roboto tw-mb-4 tw-mt-2">Change Options?</h2>
          <h4>Choosing this option requires any the following options.</h4>
          <!-- {{ selectedChromeCodeOption }} -->
          <!-- {{ filteredSubOptions.map((item) => item.chromeOptionCode) }} -->
          <!-- {{ toggleOptionData.style.configurationState.serializedValue }} -->
          <div>
            <div class="tw-flex tw-justify-between tw-w-full tw-items-center tw-mt-4">
              <v-radio-group v-model="selectedOption">
                <v-radio
                  v-for="option in filteredSubOptions"
                  :key="option.chromeOptionCode"
                  :label="option.descriptions[0].description"
                  :value="option.chromeOptionCode"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
        </div>
        <template v-slot:actions>
          <v-btn
            @click="cancelCompareVariants"
            class="tw-h-9 tw-w-24 tw-font-sans !tw-font-extralight !tw-bg-black !tw-text-white hover:!tw-bg-gray-200 hover:!tw-text-black"
            variant="tonal"
          >
            Cancel
          </v-btn>
          <v-btn
            @click="compareVariants"
            class="tw-h-9 tw-w-24 tw-font-sans !tw-font-extralight !tw-bg-black !tw-text-white hover:!tw-bg-gray-200 hover:!tw-text-black"
            variant="tonal"
          >
            Apply
          </v-btn>
        </template>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { useCarsStore } from '@/stores/useCarsStore';
import { storeToRefs } from 'pinia';
import { ref } from 'vue';
const emit = defineEmits(['toggleDialog']);
defineProps(['conflictResolvingChromeOptionCodes', 'filteredSubOptions']);
const model = defineModel();
const carStore = useCarsStore();
const { getOptionToggle } = carStore;
const selectedChromeCodeOption = ref(null);
const { selectedOption, modelConfigurationDetails, toggleOptionData } = storeToRefs(carStore);
const compareVariants = () => {
  selectedChromeCodeOption.value = modelConfigurationDetails.value?.options
    ?.map((option) =>
      option.options.find((item) => item.chromeOptionCode === selectedOption.value),
    )
    .filter((item) => item !== undefined);
  const serializedValue = toggleOptionData.value.style?.configurationState?.serializedValue;
  if (selectedChromeCodeOption.value && serializedValue && selectedOption.value) {
    getOptionToggle(serializedValue, String(selectedOption.value));
  }
  emit('toggleDialog');
};
const cancelCompareVariants = () => {
  emit('toggleDialog');
};
</script>

<style>
.custom-compare-checkbox .v-label {
  @apply !tw-text-sm;
}
</style>
